import clsx from "clsx"
import { Children, cloneElement, Dispatch, SetStateAction, useCallback } from "react"

import cls from "./Tabs.module.scss"

type TabsProps = {
  currentTab: string
  setCurrentTab: Dispatch<SetStateAction<string>>
  children: ReturnType<typeof Tab>[]
}

export const Tabs = ({ currentTab, setCurrentTab, children }: TabsProps) => {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      setCurrentTab(e.currentTarget.value)
    },
    [setCurrentTab]
  )

  return (
    <div className={cls.tabs}>
      {Children.map(children, (child) => cloneElement(child, child.props.value && { currentTab, handleClick }))}
    </div>
  )
}

type TabProps = {
  label: React.ReactNode
  value: string
  currentTab?: string
  handleClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const Tab = ({ label, value, currentTab, handleClick }: TabProps) => {
  return (
    <button
      type="button"
      value={value}
      className={clsx(cls.tab, currentTab === value && cls.active)}
      onClick={handleClick}
    >
      {label}
    </button>
  )
}

Tabs.Tab = Tab
